import 'regenerator-runtime/runtime';
import axios from 'axios';
import Vue from '../../plugins/vueFactory';
import VueAxios from 'vue-axios';
import VueRouter from 'vue-router';
import VueTippy, { TippyComponent } from 'vue-tippy';

import productOverviewComponent from './components/product-overview.vue';
import store from '../../store';

const productOverviewEl = document.getElementById('product-overview');

if (productOverviewEl) {
  const categories =
    JSON.parse(productOverviewEl.getAttribute('data-categories')) || {};
  const culture = productOverviewEl.getAttribute('data-culture');
  const preFilterUrl = productOverviewEl.getAttribute('data-pre-filter-url');
  const productSearchSettings =
    JSON.parse(
      productOverviewEl.getAttribute('data-product-search-settings')
    ) || {};
  const toolAdvisorBaseUrl = productOverviewEl.getAttribute(
    'data-tool-advisor-base-url'
  );
  const allProductsOverviewLink = productOverviewEl.getAttribute(
    'data-all-products-url'
  );

  if (!culture || !toolAdvisorBaseUrl) console.warn('Missing arguments');

  Vue.use(VueAxios, axios);
  Vue.use(VueRouter);

  // Init VueTippy
  Vue.use(VueTippy);

  Vue.component('Tippy', TippyComponent);

  const router = new VueRouter({
    mode: 'history',
    routes: []
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: '#product-overview',
    created: function() {
      this.$store.commit('setCulture', culture);

      if (preFilterUrl) {
        const url = new URL(preFilterUrl);
        const query = url.search.replace(/^\?+|\?+$/g, '');
        this.$store.commit('productSearch/setPreFilter', query);
      }

      this.$store.commit('productSearch/setSettings', productSearchSettings);

      this.$store.commit(
        'productSearch/setToolAdvisorBaseUrl',
        toolAdvisorBaseUrl
      );
    },
    render: h =>
      h(productOverviewComponent, {
        props: { allProductsOverviewLink, categories }
      }),
    router,
    store
  });
}
